var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"5px"},attrs:{"id":"verTT"},on:{"click":function($event){return _vm.ccEvent()}}},[_vm._v("    ")]),_c('pui-intro-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }